import { isApp } from '@/views/calculators/services/environmentService';
import { Options, Vue } from 'vue-class-component';
import { PropType } from 'vue';

@Options({
	name: 'menuBlockComponent',
	components: {},
	props: {
		model: Object as PropType<Array<any>>,
	},
})
export default class Menu extends Vue {
	model: Array<any>;
	private windowWidth: number = null;
	public trackingUrl: string;

	beforeMount() {
		this.trackingUrl = '';

		const root = document.documentElement;

		let index = 0;
		this.model.forEach((nav) => {
			root.style.setProperty(`--tab-${index}-nav-icon`, `url(${nav.svgIconReference?.url})`);
			index++;
		});
	}

	mounted() {
		this.windowWidth = innerWidth;
		addEventListener('resize', this.updateWindowWidth);
		addEventListener('click', this.closeNavigation);
		addEventListener('keydown', this.closeNavigation);
	}

	beforeUnmount() {
		removeEventListener('resize', this.updateWindowWidth);
		removeEventListener('click', this.closeNavigation);
		removeEventListener('keydown', this.closeNavigation);
	}

	get logoUrl() {
		return 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4wLjIsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxMzAgMTMwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxMzAgMTMwIiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxyZWN0IGZpbGw9IiMwMEI5RUEiIHdpZHRoPSIxMzAiIGhlaWdodD0iMTMwIi8+DQo8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNNjIsODYuM2M0LjUsMCw2LjQsMS45LDYuNSw1LjRjMCwyLjktMC4xLDUuNS0wLjEsOC43YzAsMi40LDEuMSwyLjIsMy4xLDEuNGwwLjQsMC45DQoJYy0xLjUsMS4xLTMuMSwxLjctNC44LDEuN2MtMS43LDAtMy4xLTAuNy0zLjItMi41Yy0wLjcsMS4yLTMsMi42LTUuMywyLjdjLTMuMSwwLTUuNS0xLjUtNS41LTQuMWMwLTMuMiwzLjYtNS4xLDkuOC01LjJsMC43LDANCglsMC0zLjJjMC0zLjktMi43LTQuOC01LjUtNGMwLDAsMC44LDIuOS0wLjUsNS4yYzAsMC0zLjQsMC4zLTMuNC0yLjdDNTQuMSw4OC4xLDU4LjQsODYuMyw2Miw4Ni4zeiBNNjMuMSw5Ni4zDQoJYy0zLjUsMC4xLTQuOCwxLjItNC44LDMuNWMwLDEuNCwwLjksMi43LDIuNSwyLjdjMSwwLDIuMi0wLjYsMi45LTEuN2wwLTQuNUw2My4xLDk2LjN6IE0zNCw2OS4yVjQ3LjZoLTQuM0wxMy4zLDY5LjJMMTEuMSw3MA0KCWwtMC40LDEuM2g4LjFsMC40LTEuM2wtMy4zLTAuOGw0LjItNS45bDguNiwwdjUuOUwyNi40LDcwTDI2LDcxLjNsMTAuOCwwbDAuNC0xLjNMMzQsNjkuMnogTTI4LjcsNjEuNGwtNy4yLDBsNy4yLTEwLjFWNjEuNHoNCgkgTTEyMCwxMDIuNGwtMy4xLTAuNmwwLTI0LjVsLTcuOCwxLjF2MWwyLjksMC45djYuOGMtMC45LTAuNS0yLjQtMC44LTMuNi0wLjhjLTYuMiwwLTEwLjcsMy44LTEwLjcsOS45YzAsNS42LDMuOSw4LjMsOC45LDguMw0KCWMyLjYsMCw0LjQtMS4zLDUuNS0yLjNsMC41LDIuNGw3LjQtMC45VjEwMi40eiBNMTEyLDEwMC42Yy0wLjksMS4xLTIuNiwyLjItNC4yLDIuMmMtMy41LDAtNC44LTMuMS00LjgtNi45YzAtNS40LDIuNC04LjMsNi04LjMNCgljMS4xLDAsMi4yLDAuNCwzLDFWMTAwLjZ6IE00My44LDEwMi4xVjkwLjhjMC42LTEuNCwzLTIuNiwzLjgtMi43Yy0wLjUsMy4zLDEuMiw0LjcsMS4yLDQuN2MxLjYsMCwzLjMtMS40LDMuMy0zYzAtMi0xLTMuNC0zLjQtMy40DQoJYy0yLjYsMC00LjcsMi4yLTUsMi45di0zbC03LjgsMS4xdjFsMi45LDAuOXYxMi45bC0zLjEsMC44djEuM2gxMnYtMS4zTDQzLjgsMTAyLjF6IE04NS44LDEwNC4ySDk2di0xLjNsLTMuMS0wLjgNCgljMC4xLTQuNSwwLTcuNCwwLTkuNmMwLTMuNS0xLjQtNi4yLTUuOS02LjJjLTIuOSwwLTUuNCwxLjctNi41LDMuM3YtMy4zYzAsMC01LjUsMC44LTcuOCwxLjF2MWwyLjksMC45djEyLjlsLTIuOSwwLjh2MS4zaDEwLjkNCgl2LTEuM2wtMy4xLTAuOFY5MS4yYzAuOS0xLjMsMi42LTIuOCw0LjgtMi44YzIsMCwyLjYsMS4zLDIuNiw0LjJsMCw5LjZsLTIuMywwLjhWMTA0LjJ6IE0zOS44LDY2LjJjLTAuMiwwLjUtMC40LDEuNS0wLjQsMi4yDQoJYzAsMC43LDAuMiwzLjIsMi44LDMuMmMxLjYsMCwzLjMtMC43LDUuMy0yLjlMNDYuOSw2OGMtMS42LDEtMiwxLTIuMywxYy0wLjgsMC0wLjktMC43LTAuNy0xLjFjMi02LjIsNy43LTIzLjUsNy43LTIzLjVsLTksMS40DQoJbDAsMS4xbDMuMywwLjFDNDYsNDYuOSw0Mi4xLDU5LDM5LjgsNjYuMnogTTUxLjUsNzEuM2g0LjdsMS43LTUuOGMxLTMuNCw2LjYtOS42LDguNS05LjZjMC45LDAsMCwxLjUtMS45LDcuOQ0KCWMtMSwzLjMtMi40LDcuNC0yLjQsNy40aDQuN2wxLjctNS44YzEtMy40LDYuNi05LjYsOC41LTkuNmMxLDAtMC40LDIuNi0yLjgsMTAuM2MtMC4xLDAuNS0wLjQsMS41LTAuNCwyLjJjMCwwLjcsMC4yLDMuMiwyLjgsMy4yDQoJYzEuNiwwLDMuMy0wLjcsNS4zLTIuOUw4MS41LDY4Yy0xLjYsMS0yLDEtMi4zLDFjLTAuOCwwLTAuOS0wLjctMC43LTEuMWMyLTYuMiwzLjctMTEuMiwzLjgtMTEuN2MwLjItMS42LTEtMi44LTIuNy0yLjgNCgljLTMuMSwwLTcuNyw0LjMtMTAuMiw4LjNjMC43LTEuOCwxLjktNC40LDIuMS01LjZjMC4yLTEuNS0xLTIuNi0yLjUtMi42Yy0yLjgsMC03LjMsMy43LTEwLjEsOC4zYzAsMCwxLjUtMy42LDEuNS01LjQNCgljMC0wLjctMC4xLTIuOS0yLjctMi45Yy0xLjYsMC0zLjMsMC43LTUuMywyLjlsMC42LDAuOGMxLjYtMSwyLjItMS4xLDIuNS0xLjFjMC44LDAsMC42LDAuOCwwLjUsMS4yQzUzLjksNjMuNSw1MS41LDcxLjMsNTEuNSw3MS4zDQoJeiBNNTEuOSw2OSBNMTEuMSwxMDQuMnYtMS4zbDMuNS0wLjhWODIuN2wtMy41LTAuOHYtMS4zbDExLjgsMGM3LjksMCw5LjYsMy4yLDkuNiw1LjZjMCwzLjUtNC43LDUuNS03LDUuNmMyLjUsMC4yLDguNSwxLjEsOC41LDUuOQ0KCWMwLDQtNCw2LjYtMTAuNiw2LjZIMTEuMXogTTE5LjksOTEuMmMwLjMsMCwxLDAuMSwxLjksMC4xYzIuNSwwLDUuMS0wLjgsNS4xLTQuOGMwLTMuOC0yLjQtNC40LTUuMy00LjRjLTAuMiwwLTAuOSwwLTEuNywwLjJWOTEuMnoNCgkgTTI4LjIsOTcuOGMwLTMuMy0xLjUtNS4yLTYuMi01LjJjLTEsMC0yLDAtMi4xLDAuMXY5LjhjMCwwLDEuNCwwLjQsMy41LDAuNEMyNi4zLDEwMi44LDI4LjIsMTAxLjQsMjguMiw5Ny44eiIvPg0KPC9zdmc+DQo=';
	}

	get menuLabel() {
		return 'Mit Alm. Brand';
	}

	public updateWindowWidth() {
		this.windowWidth = innerWidth;
	}

	public hasSubmenu(route) {
		const isMobile = this.windowWidth < 768;
		return !isMobile && route?.menuPoints?.length > 0;
	}

	public toggleMenu(route) {
		const menu = this.$refs[`sub-menu-${route}`];
		const toggle = this.$refs[`toggle-${route}`];
		const isOpen = (menu as any).classList.contains('open');

		this.closeActiveMenu();

		if (!isOpen) {
			(toggle as any).setAttribute('aria-expanded', 'true');
			(menu as any).classList.add('open');
		}
	}

	public closeActiveMenu() {
		const openMenu = document.querySelector('.primary-navigation__item.open');
		if (openMenu) {
			const openMenuToggle = openMenu.querySelector('.primary-navigation__link--toggle');
			openMenuToggle.setAttribute('aria-expanded', 'false');
			openMenu.classList.remove('open');
		}
	}

	public closeNavigation(event) {
		// If clicked outside menu or pressed ESC
		const cssClass = document.querySelector('.primary-navigation');
		if ((cssClass !== null && !cssClass.contains(event.target)) || event.keyCode === 27) {
			this.closeActiveMenu();
		}
	}

	public logoutUrl() {
		return '/auth/logout?applicationId=almbrand&redirectUri=https://www.almbrand.dk';
	}

	public isLoggedInAsApp() {
		return isApp();
	}
}
